/*
 * @LastEditors: Please set LastEditors
 * @Date: 2022-08-24 10:14:30
 * @LastEditTime: 2023-03-31 21:46:25
 * @Descripttion:
 */
import { btnGrayNormalHandle, TGDialogS ,teamInfo,pageDataChange,initShareFunc,bindShare,copyText,getCFArea,getchannelCode,nomsg,closeDialog,realGoodGift,compare,weekPop} from '../utils'
import { amsBtn } from '../AmsAndMilo/amsBtnTypeLimit'
import { teamParams } from '../AmsAndMilo/teamComm'
import { iActivityId, initFlow, wxBindPopId, preRolePopId, plat,isPage,backUrl } from './config'
import LoginService from '../AmsAndMilo/loginService'
import * as milo from '@tencent/milo-web'
import { AmsService } from '../AmsAndMilo/amsSubmit'
declare function need(path: string | Array<string>, cb: Function): any
declare function amsSubmit(actid: number, flowid: number): any
declare const LivelinkManager
declare const CFbind

if(isPage=='H5'){
  milo.cookie.set("backUrl",backUrl,7200,"qq.com","/"); 
}
 
if(isPage!='nq'){
if((window as any).parent.location.href.match(/https\:\/\/cfhd.cf.qq.com/)&&(window as any).parent != (window as any)) {
  milo.miloAlert = (window as any).parent.milo.miloAlert
}
}
export function initPage(needSubmit: boolean = true, popMask: boolean = false) {
  if (needSubmit) {
    milo.Lottery.init({
      plat: plat,
      iActivityId:iActivityId,
      iFlowId: initFlow,
      withAreaInfo: false,
      forbidLoading: popMask || true,
      // flowConfig: {
      //   sData: sData
      // },
      onSuccess: (callbackObj) => {
        initFunction(callbackObj)
      },
      onFail: (callbackObj) => {
        // 抽奖失败事件
        // if (callbackObj.iRet == '202') {
        //   TGDialogS(wxBindPopId)
        //   milo.miloAlert(callbackObj.sMsg)
        // } else if (callbackObj.sMsg === '抱歉，您还没有角色，无法参与~' || callbackObj.sMsg === '抱歉，您还未拥有角色，无法参与~') {
        //   // 拉起来预创角
        //   milo.miloAlert(callbackObj.sMsg)
        //   TGDialogS(preRolePopId)
        // } else {
        //   milo.miloAlert(callbackObj.sMsg)
        // }
        return
      },
    }).then(lottory => {
      lottory.getGift()
    })
  } else {
    initFunction((window as any).cfhdCallbackObj[iActivityId])
  }
}
 
if ((window as any).cfhdCallbackObj == undefined) {
  (window as any).cfhdCallbackObj = {}
}
// ;(window as any).cfhdCallbackObj[iActivityId] = { sOutValue1: '', sOutValue2: '', sOutValue3: '', sOutValue4: '', sOutValue5: '', sOutValue6: '', sOutValue7: '', sOutValue8: '' }
// 需要开发人员手工更改  NEED-TODO
var btnClassList1: Array<amsBtn> = [
  {class:'.HOLD541575_0',flowId:934808,key:'sOutValue1',postion:'0',params:{dmid1:1}},//tab1登录领木兰_dmid1
  {class:'.HOLD541575_1',flowId:934809,key:'sOutValue1',postion:'1',params:{dmid2:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab1邮件同意授权_dmid2
  {class:'.HOLD541575_2',flowId:934810,key:'sOutValue1',postion:'2',params:{dmid3:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab1邮件取消授权_dmid3
  {class:'.HOLD541575_3',flowId:934823,key:'sOutValue1',postion:'3',params:{dmid4:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1聚宝盆每日游戏_dmid4
  {class:'.HOLD541575_4',flowId:934824,key:'sOutValue1',postion:'4',params:{dmid5:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1聚宝盆每日掌火_dmid5
  {class:'.HOLD541575_5',flowId:934825,key:'sOutValue1',postion:'5',params:{dmid6:1}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_6',flowId:934825,key:'sOutValue1',postion:'6',params:{dmid6:2}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_7',flowId:934825,key:'sOutValue1',postion:'7',params:{dmid6:3}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_8',flowId:934825,key:'sOutValue1',postion:'8',params:{dmid6:4}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_9',flowId:934825,key:'sOutValue1',postion:'9',params:{dmid6:5}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_10',flowId:934825,key:'sOutValue1',postion:'10',params:{dmid6:6}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_11',flowId:934825,key:'sOutValue1',postion:'11',params:{dmid6:7}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_12',flowId:934825,key:'sOutValue1',postion:'12',params:{dmid6:8}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_13',flowId:934825,key:'sOutValue1',postion:'13',params:{dmid6:9}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_14',flowId:934833,key:'sOutValue1',postion:'14',params:{dmid7:1}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_15',flowId:934833,key:'sOutValue1',postion:'15',params:{dmid7:2}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_16',flowId:934833,key:'sOutValue1',postion:'16',params:{dmid7:3}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_17',flowId:934833,key:'sOutValue1',postion:'17',params:{dmid7:4}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_18',flowId:934833,key:'sOutValue1',postion:'18',params:{dmid7:5}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_19',flowId:934833,key:'sOutValue1',postion:'19',params:{dmid7:6}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_20',flowId:934833,key:'sOutValue1',postion:'20',params:{dmid7:7}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_21',flowId:934833,key:'sOutValue1',postion:'21',params:{dmid7:8}},//tab1-在线风暴_dmid7
  {class:'.HOLD541575_22',flowId:934952,key:'sOutValue1',postion:'22',params:{dmid8:1}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_23',flowId:934952,key:'sOutValue1',postion:'23',params:{dmid8:2}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_24',flowId:934952,key:'sOutValue1',postion:'24',params:{dmid8:3}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_25',flowId:934952,key:'sOutValue1',postion:'25',params:{dmid8:4}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_26',flowId:934952,key:'sOutValue1',postion:'26',params:{dmid8:5}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_27',flowId:934952,key:'sOutValue1',postion:'27',params:{dmid8:6}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_28',flowId:934952,key:'sOutValue1',postion:'28',params:{dmid8:7}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_29',flowId:934952,key:'sOutValue1',postion:'29',params:{dmid8:8}},//tab3-限时8选2_dmid8
  {class:'.HOLD541575_30',flowId:935150,key:'sOutValue1',postion:'30',params:{dmid9:1},needInitSubmit:true,customMsg:'恭喜您成功提升等级~',btnStr:'已升级'},//tab3-提升活跃等级_dmid9
  {class:'.HOLD541575_31',flowId:935151,key:'sOutValue1',postion:'31',params:{dmid10:1}},//tab3-团队人数奖励_dmid10
  {class:'.HOLD541575_32',flowId:935151,key:'sOutValue1',postion:'32',params:{dmid10:2}},//tab3-团队人数奖励_dmid10
  {class:'.HOLD541575_33',flowId:935151,key:'sOutValue1',postion:'33',params:{dmid10:3}},//tab3-团队人数奖励_dmid10
  {class:'.HOLD541575_34',flowId:935151,key:'sOutValue1',postion:'34',params:{dmid10:4}},//tab3-团队人数奖励_dmid10
  {class:'.HOLD541575_35',flowId:935152,key:'sOutValue1',postion:'35',params:{dmid11:1}},//tab3-活跃等级奖励_dmid11
  {class:'.HOLD541575_36',flowId:935152,key:'sOutValue1',postion:'36',params:{dmid11:2}},//tab3-活跃等级奖励_dmid11
  {class:'.HOLD541575_37',flowId:935152,key:'sOutValue1',postion:'37',params:{dmid11:3}},//tab3-活跃等级奖励_dmid11
  {class:'.HOLD541575_38',flowId:935152,key:'sOutValue1',postion:'38',params:{dmid11:4}},//tab3-活跃等级奖励_dmid11
  {class:'.HOLD541575_39',flowId:935152,key:'sOutValue1',postion:'39',params:{dmid11:5}},//tab3-活跃等级奖励_dmid11
  {class:'.HOLD541575_40',flowId:935152,key:'sOutValue1',postion:'40',params:{dmid11:6}},//tab3-活跃等级奖励_dmid11
  {class:'.HOLD541575_41',flowId:935193,key:'sOutValue1',postion:'41',params:{dmid12:1},before:CFfunb},//tab4-CF登录4选1_dmid12
  {class:'.HOLD541575_42',flowId:935193,key:'sOutValue1',postion:'42',params:{dmid12:2},before:CFfunb},//tab4-CF登录4选1_dmid12
  {class:'.HOLD541575_43',flowId:935193,key:'sOutValue1',postion:'43',params:{dmid12:3},before:CFfunb},//tab4-CF登录4选1_dmid12
  {class:'.HOLD541575_44',flowId:935193,key:'sOutValue1',postion:'44',params:{dmid12:4},before:CFfunb},//tab4-CF登录4选1_dmid12
  {class:'.HOLD541575_45',flowId:935198,key:'sOutValue1',postion:'45',params:{dmid13:1},before:CFfunb,needInitSubmit:true,customMsg:'恭喜您成功提升等级~',btnStr:'已升级'},//tab4-提升活跃等级_dmid13
  {class:'.HOLD541575_46',flowId:935199,key:'sOutValue1',postion:'46',params:{dmid14:1}},//tab4-团队人数奖励_dmid14
  {class:'.HOLD541575_47',flowId:935199,key:'sOutValue1',postion:'47',params:{dmid14:2}},//tab4-团队人数奖励_dmid14
  {class:'.HOLD541575_48',flowId:935199,key:'sOutValue1',postion:'48',params:{dmid14:3}},//tab4-团队人数奖励_dmid14
  {class:'.HOLD541575_49',flowId:935199,key:'sOutValue1',postion:'49',params:{dmid14:4}},//tab4-团队人数奖励_dmid14
  {class:'.HOLD541575_50',flowId:935200,key:'sOutValue1',postion:'50',params:{dmid15:1}},//tab5-活跃等级奖励_dmid15
  {class:'.HOLD541575_51',flowId:935200,key:'sOutValue1',postion:'51',params:{dmid15:2}},//tab5-活跃等级奖励_dmid15
  {class:'.HOLD541575_52',flowId:935200,key:'sOutValue1',postion:'52',params:{dmid15:3}},//tab5-活跃等级奖励_dmid15
  {class:'.HOLD541575_53',flowId:935200,key:'sOutValue1',postion:'53',params:{dmid15:4}},//tab5-活跃等级奖励_dmid15
  {class:'.HOLD541575_54',flowId:935200,key:'sOutValue1',postion:'54',params:{dmid15:5}},//tab5-活跃等级奖励_dmid15
  {class:'.HOLD541575_55',flowId:935328,key:'sOutValue1',postion:'55',params:{dmid16:1}},//tab6新玩家一键领取_dmid16
  {class:'.HOLD541575_56',flowId:935329,key:'sOutValue1',postion:'56',params:{dmid17:1},needInitSubmit:true},//tab6新玩家登录2选1_dmid17
  {class:'.HOLD541575_57',flowId:935329,key:'sOutValue1',postion:'57',params:{dmid17:2},needInitSubmit:true},//tab6新玩家登录2选1_dmid17
  {class:'.HOLD541575_58',flowId:935330,key:'sOutValue1',postion:'58',params:{dmid18:1},needInitSubmit:true},//tab6新玩家游戏2选1_dmid18
  {class:'.HOLD541575_59',flowId:935330,key:'sOutValue1',postion:'59',params:{dmid18:2},needInitSubmit:true},//tab6新玩家游戏2选1_dmid18
  {class:'.HOLD541575_60',flowId:935331,key:'sOutValue1',postion:'60',params:{dmid19:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab6登录邮件同意授权_dmid19
  {class:'.HOLD541575_61',flowId:935332,key:'sOutValue1',postion:'61',params:{dmid20:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab6登录邮件取消授权_dmid20
  {class:'.HOLD541575_62',flowId:935455,key:'sOutValue1',postion:'62',params:{dmid21:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab6游戏邮件同意授权_dmid21
  {class:'.HOLD541575_63',flowId:935456,key:'sOutValue1',postion:'63',params:{dmid22:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab6游戏邮件取消授权_dmid22
  {class:'.HOLD541575_64',flowId:935457,key:'sOutValue1',postion:'64',params:{dmid23:1}},//tab6新玩家跳页面即领_dmid23
  {class:'.HOLD541575_65',flowId:935458,key:'sOutValue1',postion:'65',params:{dmid24:1}},//tab6新玩家点下载_dmid24
  {class:'.HOLD541575_66',flowId:935459,key:'sOutValue1',postion:'66',params:{dmid25:1}},//tab6-累计登录领奖励_dmid25
  {class:'.HOLD541575_67',flowId:935459,key:'sOutValue1',postion:'67',params:{dmid25:2}},//tab6-累计登录领奖励_dmid25
  {class:'.HOLD541575_68',flowId:935459,key:'sOutValue1',postion:'68',params:{dmid25:3}},//tab6-累计登录领奖励_dmid25
  {class:'.HOLD541575_69',flowId:935459,key:'sOutValue1',postion:'69',params:{dmid25:4}},//tab6-累计登录领奖励_dmid25
  {class:'.HOLD541575_70',flowId:935459,key:'sOutValue1',postion:'70',params:{dmid25:5}},//tab6-累计登录领奖励_dmid25
  {class:'.HOLD541575_71',flowId:935459,key:'sOutValue1',postion:'71',params:{dmid25:6}},//tab6-累计登录领奖励_dmid25
  {class:'.HOLD541575_72',flowId:935460,key:'sOutValue1',postion:'72',params:{dmid26:1}},//tab6-每日任务领奖励_dmid26
  {class:'.HOLD541575_73',flowId:935460,key:'sOutValue1',postion:'73',params:{dmid26:2}},//tab6-每日任务领奖励_dmid26
  {class:'.HOLD541575_74',flowId:935460,key:'sOutValue1',postion:'74',params:{dmid26:3}},//tab6-每日任务领奖励_dmid26
  {class:'.HOLD541575_75',flowId:935461,key:'sOutValue1',postion:'75',params:{dmid27:1}},//tab6-成功分享领_dmid27
  {class:'.HOLD541575_76',flowId:935497,key:'sOutValue1',postion:'76',params:{dmid28:1}},//tab7回归玩家6选3_dmid28
  {class:'.HOLD541575_77',flowId:935497,key:'sOutValue1',postion:'77',params:{dmid28:2}},//tab7回归玩家6选3_dmid28
  {class:'.HOLD541575_78',flowId:935497,key:'sOutValue1',postion:'78',params:{dmid28:3}},//tab7回归玩家6选3_dmid28
  {class:'.HOLD541575_79',flowId:935497,key:'sOutValue1',postion:'79',params:{dmid28:4}},//tab7回归玩家6选3_dmid28
  {class:'.HOLD541575_80',flowId:935497,key:'sOutValue1',postion:'80',params:{dmid28:5}},//tab7回归玩家6选3_dmid28
  {class:'.HOLD541575_81',flowId:935497,key:'sOutValue1',postion:'81',params:{dmid28:6}},//tab7回归玩家6选3_dmid28
  {class:'.HOLD541575_82',flowId:935498,key:'sOutValue1',postion:'82',params:{dmid29:1},needInitSubmit:true},//tab7回玩家登录2选1_dmid29
  {class:'.HOLD541575_83',flowId:935498,key:'sOutValue1',postion:'83',params:{dmid29:2},needInitSubmit:true},//tab7回玩家登录2选1_dmid29
  {class:'.HOLD541575_84',flowId:935499,key:'sOutValue1',postion:'84',params:{dmid30:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab7邮件同意授权_dmid30
  {class:'.HOLD541575_85',flowId:935500,key:'sOutValue1',postion:'85',params:{dmid31:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab7邮件取消授权_dmid31
  {class:'.HOLD541575_86',flowId:935501,key:'sOutValue1',postion:'86',params:{dmid32:1}},//tab7老玩家进web云游戏_dmid32
  {class:'.HOLD541575_87',flowId:935502,key:'sOutValue1',postion:'87',params:{dmid33:1}},//tab7老玩家点下载_dmid33
  {class:'.HOLD541575_88',flowId:935523,key:'sOutValue1',postion:'88',params:{dmid34:1}},//tab7-累登领奖励_dmid34
  {class:'.HOLD541575_89',flowId:935523,key:'sOutValue1',postion:'89',params:{dmid34:2}},//tab7-累登领奖励_dmid34
  {class:'.HOLD541575_90',flowId:935523,key:'sOutValue1',postion:'90',params:{dmid34:3}},//tab7-累登领奖励_dmid34
  {class:'.HOLD541575_91',flowId:935523,key:'sOutValue1',postion:'91',params:{dmid34:4}},//tab7-累登领奖励_dmid34
  {class:'.HOLD541575_92',flowId:935523,key:'sOutValue1',postion:'92',params:{dmid34:5}},//tab7-累登领奖励_dmid34
  {class:'.HOLD541575_93',flowId:935523,key:'sOutValue1',postion:'93',params:{dmid34:6}},//tab7-累登领奖励_dmid34
  {class:'.HOLD541575_94',flowId:935524,key:'sOutValue1',postion:'94',params:{dmid35:1}},//tab7-每日任务领奖励_dmid35
  {class:'.HOLD541575_95',flowId:935524,key:'sOutValue1',postion:'95',params:{dmid35:2}},//tab7-每日任务领奖励_dmid35
  {class:'.HOLD541575_96',flowId:935524,key:'sOutValue1',postion:'96',params:{dmid35:3}},//tab7-每日任务领奖励_dmid35
  {class:'.HOLD541575_97',flowId:935525,key:'sOutValue1',postion:'97',params:{dmid36:1}},//tab7-成功分享领_dmid36

  {class:'.HOLD541575_98',flowId:935554,key:'sOutValue1',postion:'98',params:{dmid37:1},needInitSubmit:true,btnStr:'已抽取'},//tab2每日掌火抽卡片_dmid37
  {class:'.HOLD541575_99',flowId:935559,key:'sOutValue1',postion:'99',params:{dmid38:1},needInitSubmit:true,btnStr:'已抽取'},//tab2斗鱼虎牙抽卡_dmid38
  {class:'.HOLD541575_100',flowId:935559,key:'sOutValue1',postion:'100',params:{dmid38:2},needInitSubmit:true,btnStr:'已抽取'},//tab2斗鱼虎牙抽卡_dmid38
  {class:'.HOLD541575_101',flowId:936320,key:'sOutValue1',postion:'101',params:{dmid39:1},needInitSubmit:true,btnStr:'已抽取'},//tab2快手抽卡片_dmid39
  {class:'.HOLD541575_102',flowId:936325,key:'sOutValue1',postion:'102',params:{dmid40:1},needInitSubmit:true,btnStr:'已兑换'},//tab2-4张卡牌兑换奖励_dmid40
  {class:'.HOLD541575_103',flowId:936325,key:'sOutValue1',postion:'103',params:{dmid40:2},needInitSubmit:true,btnStr:'已兑换'},//tab2-4张卡牌兑换奖励_dmid40
  {class:'.HOLD541575_104',flowId:936325,key:'sOutValue1',postion:'104',params:{dmid40:3},needInitSubmit:true,btnStr:'已兑换'},//tab2-4张卡牌兑换奖励_dmid40
  {class:'.HOLD541575_105',flowId:936325,key:'sOutValue1',postion:'105',params:{dmid40:4},needInitSubmit:true,btnStr:'已兑换'},//tab2-4张卡牌兑换奖励_dmid40
  {class:'.HOLD541575_106',flowId:936328,key:'sOutValue1',postion:'106',params:{dmid41:1},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_107',flowId:936328,key:'sOutValue1',postion:'107',params:{dmid41:2},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_108',flowId:936328,key:'sOutValue1',postion:'108',params:{dmid41:3},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_109',flowId:936328,key:'sOutValue1',postion:'109',params:{dmid41:4},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_110',flowId:936328,key:'sOutValue1',postion:'110',params:{dmid41:5},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_111',flowId:936328,key:'sOutValue1',postion:'111',params:{dmid41:6},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_112',flowId:936328,key:'sOutValue1',postion:'112',params:{dmid41:7},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_113',flowId:936328,key:'sOutValue1',postion:'113',params:{dmid41:8},needInitSubmit:true,btnStr:'已兑换'},//tab2-3张卡牌兑换奖励_dmid41
  {class:'.HOLD541575_114',flowId:936329,key:'sOutValue1',postion:'114',params:{dmid42:1},needInitSubmit:true,btnStr:'已兑换'},//tab2-2张卡牌兑换奖励_dmid42
  {class:'.HOLD541575_115',flowId:936329,key:'sOutValue1',postion:'115',params:{dmid42:2},needInitSubmit:true,btnStr:'已兑换'},//tab2-2张卡牌兑换奖励_dmid42
  {class:'.HOLD541575_116',flowId:936329,key:'sOutValue1',postion:'116',params:{dmid42:3},needInitSubmit:true,btnStr:'已兑换'},//tab2-2张卡牌兑换奖励_dmid42
  {class:'.HOLD541575_117',flowId:936329,key:'sOutValue1',postion:'117',params:{dmid42:4},needInitSubmit:true,btnStr:'已兑换'},//tab2-2张卡牌兑换奖励_dmid42
  {class:'.HOLD541575_118',flowId:936332,key:'sOutValue1',postion:'118',params:{dmid43:1},needInitSubmit:true,btnStr:'已兑换'},//tab2-1张卡牌兑换奖励_dmid43
  {class:'.HOLD541575_119',flowId:936332,key:'sOutValue1',postion:'119',params:{dmid43:2},needInitSubmit:true,btnStr:'已兑换'},//tab2-1张卡牌兑换奖励_dmid43
  {class:'.HOLD541575_120',flowId:936332,key:'sOutValue1',postion:'120',params:{dmid43:3},needInitSubmit:true,btnStr:'已兑换'},//tab2-1张卡牌兑换奖励_dmid43
  {class:'.HOLD541575_121',flowId:936332,key:'sOutValue1',postion:'121',params:{dmid43:4},needInitSubmit:true,btnStr:'已兑换'},//tab2-1张卡牌兑换奖励_dmid43
  {class:'.HOLD541575_122',flowId:936332,key:'sOutValue1',postion:'122',params:{dmid43:5},needInitSubmit:true,btnStr:'已兑换'},//tab2-1张卡牌兑换奖励_dmid43

  {class:'.HOLD541575_123',flowId:936826,key:'sOutValue1',postion:'123',params:{dmid44:1}},//tab8-双端游戏一局抽奖_dmid44
  {class:'.HOLD541575_124',flowId:936830,key:'sOutValue1',postion:'124',params:{dmid45:1}},//tab8-游戏or登录领_dmid45
  {class:'.HOLD541575_125',flowId:936833,key:'sOutValue1',postion:'125',params:{dmid46:1}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_126',flowId:936833,key:'sOutValue1',postion:'126',params:{dmid46:2}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_127',flowId:936833,key:'sOutValue1',postion:'127',params:{dmid46:3}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_128',flowId:936833,key:'sOutValue1',postion:'128',params:{dmid46:4}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_129',flowId:936833,key:'sOutValue1',postion:'129',params:{dmid46:5}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_130',flowId:936833,key:'sOutValue1',postion:'130',params:{dmid46:6}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_131',flowId:936833,key:'sOutValue1',postion:'131',params:{dmid46:7}},//tab8-当天登录7选2_dmid46
  {class:'.HOLD541575_132',flowId:936925,key:'sOutValue1',postion:'132',params:{dmid47:1}},//tab9游戏一局领奖励_dmid47
  {class:'.HOLD541575_133',flowId:936934,key:'sOutValue1',postion:'133',params:{dmid48:1}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_134',flowId:936934,key:'sOutValue1',postion:'134',params:{dmid48:2}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_135',flowId:936934,key:'sOutValue1',postion:'135',params:{dmid48:3}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_136',flowId:936934,key:'sOutValue1',postion:'136',params:{dmid48:4}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_137',flowId:936934,key:'sOutValue1',postion:'137',params:{dmid48:5}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_138',flowId:936934,key:'sOutValue1',postion:'138',params:{dmid48:6}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_139',flowId:936934,key:'sOutValue1',postion:'139',params:{dmid48:7}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_140',flowId:936934,key:'sOutValue1',postion:'140',params:{dmid48:8}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_141',flowId:936934,key:'sOutValue1',postion:'141',params:{dmid48:9}},//tab9-当天登录9选2_dmid48
  {class:'.HOLD541575_142',flowId:936941,key:'sOutValue1',postion:'142',params:{dmid49:1}},//tab9-累计登录领奖励_dmid49
  {class:'.HOLD541575_143',flowId:936941,key:'sOutValue1',postion:'143',params:{dmid49:2}},//tab9-累计登录领奖励_dmid49
  {class:'.HOLD541575_144',flowId:936941,key:'sOutValue1',postion:'144',params:{dmid49:3}},//tab9-累计登录领奖励_dmid49
  {class:'.HOLD541575_145',flowId:936941,key:'sOutValue1',postion:'145',params:{dmid49:4}},//tab9-累计登录领奖励_dmid49
  {class:'.HOLD541575_146',flowId:936941,key:'sOutValue1',postion:'146',params:{dmid49:5}},//tab9-累计登录领奖励_dmid49
  {class:'.HOLD541575_147',flowId:936980,key:'sOutValue1',postion:'147',params:{dmid50:1}},//tab9-分享新回领奖励_dmid50
  {class:'.HOLD541575_148',flowId:936980,key:'sOutValue1',postion:'148',params:{dmid50:2}},//tab9-分享新回领奖励_dmid50
  {class:'.HOLD541575_149',flowId:936980,key:'sOutValue1',postion:'149',params:{dmid50:3}},//tab9-分享新回领奖励_dmid50
  {class:'.HOLD541575_150',flowId:937444,key:'sOutValue1',postion:'150',params:{dmid51:1}},//ta8-双区游戏一局抽奖_dmid51
  {class:'.HOLD541575_151',flowId:937446,key:'sOutValue1',postion:'151',params:{dmid52:1},customMsg:'预约成功~',btnStr:'已预约'},//公共模块-立即预约_dmid52
  {class:'.HOLD541575_152',flowId:937448,key:'sOutValue1',postion:'152',params:{dmid53:1}},//公共模块-成功分享领_dmid53
  {class:'.HOLD541575_153',flowId:937449,key:'sOutValue1',postion:'153',params:{dmid54:1}},//公共模块-预约领_dmid54（20号之后开）
  {class:'.HOLD541575_154',flowId:938081,key:'sOutValue1',postion:'154',params:{dmid55:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1-斗鱼积分升级_dmid55
  {class:'.HOLD541575_155',flowId:938081,key:'sOutValue1',postion:'155',params:{dmid55:2},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1-斗鱼积分升级_dmid55



{class:'.NOHOLD541575_4',flowId:934857,params:{sEncrypt:milo.request('sEncrypt')}},//tab1接受邀请-登录条件放开
{class:'.NOHOLD541575_5',flowId:934860,needInitSubmit:true},//tab1-抽盲盒
{class:'.NOHOLD541575_6',flowId:934951,params:{sEncrypt:milo.request('sEncrypt')}},//tab3接受邀请-登录条件放开
{class:'.NOHOLD541575_7',flowId:935146,needInitSubmit:true},//tab3-创建队伍
{class:'.NOHOLD541575_8',flowId:935147,before:getTeamid,needInitSubmit:true},//tab3-加入队伍
{class:'.NOHOLD541575_9',flowId:935148,needInitSubmit:true,resolve:nomsg,reject:nomsg},//tab3-换一批
{class:'.NOHOLD541575_10',flowId:935149,needInitSubmit:true},//tab3-成为推荐
{class:'.NOHOLD541575_11',flowId:935194,before:CFfunb,needInitSubmit:true},//tab4-创建队伍
{class:'.NOHOLD541575_12',flowId:935195,before:getTeamid2,needInitSubmit:true},//tab4-加入队伍
{class:'.NOHOLD541575_13',flowId:935196,needInitSubmit:true,resolve:nomsg,reject:nomsg},//tab4-换一批
{class:'.NOHOLD541575_14',flowId:935197,needInitSubmit:true},//tab4-成为推荐

{class:'.NOHOLD541575_15',flowId:935462,params:{sEncrypt:milo.request('sEncrypt')}},//tab6接受邀请-登录条件放开
{class:'.NOHOLD541575_16',flowId:935526,params:{sEncrypt:milo.request('sEncrypt')}},//tab7接受邀请-登录条件放开

{class:'.NOHOLD541575_17',flowId:936323,needInitSubmit:true},//tab2-4张卡牌抽奖
{class:'.bdchdks',flowId:936568,needInitSubmit:true,customMsg:'绑定成功~'},//tab2-4张卡牌抽奖


{class:'.NOHOLD541575_18',flowId:936943,resolve:nomsg,reject:nomsg},//tab9-点分享
{class:'.NOHOLD541575_19',flowId:936944,params:{sEncrypt:milo.request('sEncrypt')}},//tab9接受邀请-登录条件放开
{class:'.NOHOLD541575_20',flowId:936976},//tab9-成功分享抽奖
{class:'.NOHOLD541575_21',flowId:937447,params:{sEncrypt:milo.request('sEncrypt')},resolve:yyfun},//公共模块-接受邀请

{class:'.t8gift1',flowId:936851,params:{giftid:1}},//tab8-完成任务抽礼盒
{class:'.t8gift2',flowId:936851,params:{giftid:2}},//tab8-完成任务抽礼盒
{class:'.t8gift3',flowId:936851,params:{giftid:3}},//tab8-完成任务抽礼盒
{class:'.t8gift4',flowId:936851,params:{giftid:4}},//tab8-完成任务抽礼盒
{class:'.t8gift5',flowId:936851,params:{giftid:5}},//tab8-完成任务抽礼盒

{class:'.sandcard1',flowId:936345,params:{cardid:1},before:sendcard1,needInitSubmit:true,customMsg:'赠送成功~'},//tab2-赠送卡牌
{class:'.sandcard2',flowId:936345,params:{cardid:2},before:sendcard2,needInitSubmit:true,customMsg:'赠送成功~'},//tab2-赠送卡牌
{class:'.sandcard3',flowId:936345,params:{cardid:3},before:sendcard3,needInitSubmit:true,customMsg:'赠送成功~'},//tab2-赠送卡牌
{class:'.sandcard4',flowId:936345,params:{cardid:4},before:sendcard4,needInitSubmit:true,customMsg:'赠送成功~'},//tab2-赠送卡牌

{class:'.yunGame',flowId:934748,params:{click:1},resolve:yunGamejump,reject:yunGamejump},//新、老玩家点下载和跳转
{class:'.downGame',flowId:934748,params:{click:2},before:gameDownBefore,resolve:gameDown,reject:gameDown},//新、老玩家点下载和跳转

{class:'.NOHOLD541575_0',flowId:934720,before:getNameAndChannel,customMsg:'创建成功~'},//预创角
{class:'.widget',flowId:934719,before:getChannelItem,needInitSubmit:false},//渠道礼包领取




//人拉人引用 
{class:'.HOLD541321_0',flowId:934486,config: {iActivityId: 541321,giftId: 538599},params:{dmid1:1},before:kolcfhddh},//tab1-兑换礼_dmid1
{class:'.HOLD541321_0_1',flowId:934486,config: {iActivityId: 541321,giftId: 538599},params:{dmid1:1},before:kolcfhddh2},//tab1-兑换礼_dmid1
{class:'.HOLD541321_0_2',flowId:934486,config: {iActivityId: 541321,giftId: 538599},params:{dmid1:1},before:kolcfhddh3},//tab1-兑换礼_dmid1
{class:'.HOLD541321_1',flowId:934487,config: {iActivityId: 541321,giftId: 538599},params:{dmid2:1}},//tab1-登录礼_dmid2
{class:'.HOLD541321_28',flowId:934502,config: {iActivityId: 541321,giftId: 538599},params:{dmid19:1}},//tab3-大咖认证礼_dmid19
{class:'.NOHOLD541321_1',flowId:934490,config: {iActivityId: 541321,giftId: 538599},needInitSubmit:true,customMsg:'恭喜您成功生成KOL口令码~'},//tab1-生成大咖码
]

const tab8CF = [
  {class:'.tab8_cf_func_gift1',flowId:937590, config: { iActivityId: 540298,giftId: 537920 } ,params:{dmid12:1, area: 0 },before:CFfunb},//tab8CF礼包
  {class:'.tab8_cf_func_gift2',flowId:937591, config: { iActivityId: 540298,giftId: 539103 } ,params:{dmid12:1, area: 0 },before:CFfunb},//tab8CF礼包
]

export const allBtn = [...btnClassList1, ...tab8CF]
export const amsService = new AmsService(allBtn) // amsService.allBtnPromise.get(890999).then((res) => { res.getGift() })可以这样调用, 也可以在别的页面应用amsService去调动

const dataPosition= ['gameweeks','jbpdj','cjnums','gamenow','t3news','t3olds','t1hy','t1olds','loginnums','gameweeks11','mlcard','yfcard','hxcard','xycard','cardnums','dynums','hynums','xhcardnums','cardtypes','t8login','t9login','t9hynums','t9newolds']
let pcUrl = 'https://cfhd.cf.qq.com/cp/a20230401act/index.html'
let h5Url = 'https://cfhd.cf.qq.com/cp/a20230401act/m.html'
let pagtInitStatus = 0;
let tab1Share:any;
let tab2Share:any;
let tab3Share:any;
let tab4Share:any;
let tab6Share:any;
let tab7Share:any;
let tab8Share:any;
let tab2TeamId:string;
let tab5TeamId:string;
let tab8TeamId:string;
let myKOLcode:string;
let cardinfo = [];

let area = 0;


// 初始化成功回调

// 需要开发人员手工更改  NEED-TODO
export function initFunction(callbackObj) {
  ;(window as any).cfhdCallbackObj[iActivityId] = callbackObj
  // 按钮置灰
  btnGrayNormalHandle((window as any).cfhdCallbackObj[iActivityId], allBtn, 'gray disable')
  // 页面数据处理
  pageDataChange((window as any).cfhdCallbackObj[iActivityId].sOutValue3,dataPosition)
  const DataArr = callbackObj.sOutValue3.split(',')

  
  let shareArr = callbackObj.sOutValue2.split(',')   
  myKOLcode = shareArr[1]==0?'':shareArr[1];
  $(".MYKOLCODE").val(myKOLcode);
  if(shareArr[3]>0){
    let listarr = {1:'VECTOR 五虎将-张飞',2:'沙漠之鹰 茉莉',3:'M14EBR 神罚天使',4:'轻型军用手斧 紫罗兰'};
    $(".hsdj").text(listarr[shareArr[3]]);
    if(shareArr[3]<3){
      $(".HOLD541575_62_1").attr('href',"javascript:TGDialogS('tab6_pop4')");
    }else{
      $(".HOLD541575_84_1").attr('href',"javascript:TGDialogS('tab7_pop1')");			
    }
   }
  
   if(shareArr[4]>0){
    let listarr2 = {1:'QBZ-191+QBZ-191  美猴王',2:'AK-47+AK-47  牡丹'};
    $(".hsdj1").text(listarr2[shareArr[4]]);
    $(".HOLD541575_60_1").attr('href',"javascript:TGDialogS('tab6_pop2')");
   }

  const zgarr = callbackObj.sOutValue1.split(',')
  if(zgarr[1]>0){
    $(".HOLD541575_1_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD541575_1_1").addClass('gray');
    $(".HOLD541575_1_1").text('已开启');
  }
  if(zgarr[2]>0){
    $(".HOLD541575_2_2").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD541575_2_2").addClass('gray');
    $(".HOLD541575_2_2").text('已取消');
  } 


  if(zgarr[60]>0){
    $(".HOLD541575_60_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD541575_60_1").addClass('gray');
    $(".HOLD541575_60_1").text('已开启');
  }
  if(zgarr[61]>0){
    $(".HOLD541575_61_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD541575_61_1").addClass('gray');
    $(".HOLD541575_61_1").text('已取消');
  }

  if(zgarr[62]>0){
    $(".HOLD541575_62_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD541575_62_1").addClass('gray');
    $(".HOLD541575_62_1").text('已开启');
  }
  if(zgarr[63]>0){
    $(".HOLD541575_63_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD541575_63_1").addClass('gray');
    $(".HOLD541575_63_1").text('已取消');
  } 

  if(zgarr[84]>0){
    $(".HOLD541575_84_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD541575_84_1").addClass('gray');
    $(".HOLD541575_84_1").text('已开启');
  }
  if(zgarr[85]>0){
    $(".HOLD541575_85_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD541575_85_1").addClass('gray');
    $(".HOLD541575_85_1").text('已取消');
  } 
  if(zgarr[99]>0){
    $(".dynums").text(0);
  }
  if(zgarr[100]>0){
    $(".hynums").text(0);
  }
  
  let res4 = callbackObj.sOutValue4.split(',');
  
  for (var i=0;i<res4.length ;i++ ){
    if(res4[i]>0){
     $(".isxssy_"+i).text('是');
    }else{
     $(".isxssy_"+i).html('否');			
    }
  }
  
  cardinfo = callbackObj.sOutValue5.split(',');
  for(var i=0;i<4;i++){
    $(".cardscode_"+i).val(cardinfo[i])
  }
  const tab2Team = {
    teamInfo:(window as any).cfhdCallbackObj[iActivityId].sOutValue7,
    joinClass:".tab2_team",
    notJoinClass:".dont_join_team",
    teamIdClass:".team_id",
    tjBtnClass:".tjTeam",
    teamCountClass:".team_count",
    teamLevelJfName:"teamjfNum",
    jbpTeamLevelJfName:"",
    peopleLevelJfName:"peopleLevel",
    jbpPeopleLevelJfName:"",
    tjTeamListClass:".tab2_team_list"
  }

  tab2TeamId = teamInfo(tab2Team,935147);
  const tab5Team = {
    teamInfo:(window as any).cfhdCallbackObj[iActivityId].sOutValue8,
    joinClass:".tab4_team",
    notJoinClass:".dont_join_team2",
    teamIdClass:".team_id2",
    tjBtnClass:".tjTeam2",
    teamCountClass:".team_count2",
    teamLevelJfName:"teamjfNum2",
    jbpTeamLevelJfName:"",
    peopleLevelJfName:"peopleLevel2",
    jbpPeopleLevelJfName:"",
    tjTeamListClass:".tab4_team_list"
  }
  tab5TeamId = teamInfo(tab5Team,935195);

  if(shareArr[6]<1){
    //$(".bdkszh").hide();
    $(".bdchdks").text('绑定账号到此活动');    
    $(".bdchdks").show();    
  }
  if(shareArr[7]){
    $(".bdkszh").text(shareArr[7]);   
  }else{
    $(".bdkszh").text('绑定快手账号');  
  } 
  if(shareArr[5]>0){
    $(".bdkszh").show(); 
    $(".bdchdks").hide();    
  }
  

  if(pagtInitStatus==0){
    
    pcUrl += '?sEncrypt=' + shareArr[0]
    h5Url += '?sEncrypt=' + shareArr[0]

    ;(window as any).tab1Share=initShareFunc(pcUrl+'&ctypeId=1',h5Url+'&ctypeId=1','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share.jpg',{width:195,height:175,class:'#tab1-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=1',{pcBtnClass: '.fxhy1',h5BtnClass: '.fxh51',zoneBtnClass: '.fxqq1',copyBtnClass: '.fxcp1',inputValClass: '#t1copytext'},(window as any).tab1Share);

    ;(window as any).tab2Share=initShareFunc(pcUrl+'&ctypeId=2',h5Url+'&ctypeId=2','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share2.jpg',{width:195,height:175,class:'#tab2-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=2',{pcBtnClass: '.fxhy2',h5BtnClass: '.fxh52',zoneBtnClass: '.fxqq2',copyBtnClass: '.fxcp2',inputValClass: '#t2copytext'},(window as any).tab2Share);

    ;(window as any).tab3Share=initShareFunc(pcUrl+'&ctypeId=3',h5Url+'&ctypeId=3','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share3.jpg',{width:175,height:175,class:'#tab3-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=3',{pcBtnClass: '.fxhy3',h5BtnClass: '.fxh53',zoneBtnClass: '.fxqq3',copyBtnClass: '.fxcp3',inputValClass: '#t3copytext'},(window as any).tab3Share);

    ;(window as any).tab4Share=initShareFunc(pcUrl+'&ctypeId=4',h5Url+'&ctypeId=4','CFHD海量枪械，刺激枪战！','邀你来领海量礼包福利','邀你来领海量礼包福利','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share4.jpg',{width:195,height:195,class:'#tab4-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=4',{pcBtnClass: '.fxhy4',h5BtnClass: '.fxh54',zoneBtnClass: '.fxqq4',copyBtnClass: '.fxcp4',inputValClass: '#t4copytext'},(window as any).tab4Share);

    ;(window as any).tab6Share=initShareFunc(pcUrl+'&ctypeId=5',h5Url+'&ctypeId=5','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share5.jpg',{width:232,height:234,class:'#tab6-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=5',{pcBtnClass: '.fxhy6',h5BtnClass: '.fxh56',zoneBtnClass: '.fxqq6',copyBtnClass: '.fxcp6',inputValClass: '#t6copytext'},(window as any).tab6Share);
    
    ;(window as any).tab7Share=initShareFunc(pcUrl+'&ctypeId=6',h5Url+'&ctypeId=6','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share6.jpg',{width:225,height:225,class:'#tab7-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=6',{pcBtnClass: '.fxhy7',h5BtnClass: '.fxh57',zoneBtnClass: '.fxqq7',copyBtnClass: '.fxcp7',inputValClass: '#t7copytext'},(window as any).tab7Share);
    ;(window as any).tab8Share=initShareFunc(pcUrl+'&ctypeId=6',h5Url+'&ctypeId=6','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230401act/share6.jpg',{width:225,height:225,class:'#tab8-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=6',{pcBtnClass: '.fxhy8',h5BtnClass: '.fxh58',zoneBtnClass: '.fxqq8',copyBtnClass: '.fxcp8',inputValClass: '#t8copytext'},(window as any).tab8Share);

    if (milo.request('sEncrypt') && milo.request('sEncrypt') != shareArr[0]) {
      if(milo.request('ctypeId') == 1){
        TGDialogS('tab1_pop3');//TAB1-接受邀请 
      }else if(milo.request('ctypeId') == 2){
        TGDialogS('tab3_pop1');//TAB3-接受邀请
      }else if(milo.request('ctypeId') == 3){
        TGDialogS('tab6_pop1');//TAB6-接受邀请
      }else if(milo.request('ctypeId') == 4){
        TGDialogS('tab7_pop3');//TAB7-接受邀请
      }else if(milo.request('ctypeId') == 5){
        TGDialogS('tab9_pop1');//TAB9-接受邀请 
      }else if(milo.request('ctypeId') == 6){
        TGDialogS('popa4');//公共模块-接受邀请
      }
    }else{ 
      if(shareArr[2] == 1){
        (window as any).jump(7,'.tab-ct7');
      }else if(shareArr[2] == 2 || shareArr[2] == 4){
        (window as any).jump(6,'.tab-ct6');
      }
    }
    if (!milo.request('sEncrypt')) {
      weekPop(1)
    }
    if(isPage=='index'){
      qqlist()
    }
    
    pagtInitStatus = 1
  }
}

//失败提示
function tsmsg(callbackObj,ele){
  if(callbackObj.sMsg == '抱歉，您不满足条件，无法领取哦~'){
    milo.miloAlert(callbackObj.sMsg+"提示：本活动目前1局时长暂时需40分钟，正在加速优化中，给您带来不便敬请谅解。");
  }else{
    milo.miloAlert(callbackObj.sMsg);
  }
}

//执行传CF大区的方法
function CFfunb(ele){
  if(area>0){
    ;(window as any)[`sData${ele.class}`].area = area
    return true;
  }else{
    CFbind.initbind('myarea','bindarea()')
    return false;
  }
}


//加入团队
function joinTeam(tid,fid){
  if(fid==922015){
    if(area==0){
      CFbind.initbind('myarea','bindarea()')
      return false;
    }
  }
  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
    plat: plat,
    iActivityId: iActivityId,
    iFlowId: fid,
    withAreaInfo: false,
    forbidLoading: false,
    flowConfig:{
      sData: {
        'team_id':tid,
        'area':area
      }
    },
    onSuccess: (res) => {
      console.log(res)
      milo.miloAlert("加团成功~")
      initPage()
    },
    onFail: (err) => {
      milo.miloAlert(err.sMsg)
    },
  })
}


//购买
function djcbuy() {
  LoginService(isPage)
  .checkAndLogin()
  .then((check) => {
    amsSubmit(541321,934488)
  }) 
  
}

;(window as any).amsCfg_934488 = {
  'iActivityId' : '541321',
  'iFlowId' : '934488',
  'sData'	: {'sArea':600},
  '_everyRead': true, //_everyRead参数用于控制缓存，设为true表示每次发请求都会读取amsCfg参数的值，建议加上
  'fFlowSubmitEnd': function(res) {
    need(["ams.daoju_buy_svr.daoju_buy_svr"], function(DaojuBuy) {
      var option = {
        //apptype:4	新版webpay，已默认
        onPaySuccess:function(){
          //$(".38buy").addClass('gray').text('已购买')
        },//支付成功后回调方法
        //onPayClose:function(){}//关闭支付页面回调方法
      };
      DaojuBuy.svrPay(res.jData,option);
    });
  }, 
  'fFlowSubmitFailed':function(res) {
    milo.miloAlert(res.sMsg);
  }
};


//kol奖励兑换
function kolcfhddh(ele) {
  let kolcode = $(".kol-input").val();
  if(kolcode==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode
  return true;
}

//kol奖励兑换
function kolcfhddh2(ele) {
  let kolcode2 = $(".kol-input2").val();
  if(kolcode2==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode2
  return true;
}
//kol奖励兑换
function kolcfhddh3(ele) {
  let kolcode3 = $(".kol-input3").val();
  if(kolcode3==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode3
  return true;
}
//拉取好友列表
let fuin = "";
let ftype = "";
let fex1 = "";
let algo_type = "";

function qqlist(){

  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
      plat: 'pc',
      iActivityId: '541575',
      iFlowId: '934774',
      withAreaInfo: false,
      onSuccess: (res) => {
          var list = res.jData.recommendlist;
          //if(list.length>0){
         /**var list = [
            {
              "userid": "1844137343",
              "nickname": "好友3",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "3091215065",
              "nickname": "好友4",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "1409602525",
              "nickname": "好友5",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "1956406663",
              "nickname": "好友6",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "3120507715",
              "nickname": "好友7",
              "friendtype": "2",
              "ext1": "2"
            }
          ]**/
          if(list!=null){
            var qqlisthtml = '';
            var qqlisthtml5 = '';
            fuin = "";
            ftype = "";
            fex1 = "";
            algo_type = "";
            for (var i=0;i<list.length ;i++ ){
              qqlisthtml +=  '<tr>';
              qqlisthtml +=  		'<td>'+resetqq(list[i]['userid'])+' </td>';
              qqlisthtml +=  		'<td>'+list[i]['nickname']+'</td>';
              qqlisthtml +=  		'<td><div class="codec"><img src="http://q3.qlogo.cn/headimg_dl?bs=uin&dst_uin='+list[i]["userid"]+'&spec=100&url_enc=0&referer=bu_interface&term_type=PC" alt=""></div></td>';
              qqlisthtml +=  		'<td><a href="javascript:sendqq('+list[i]["userid"]+',1,0,'+list[i]["friendtype"]+','+list[i]["ext1"]+');" class="btn-zs1 sp2"  onclick="PTTSendClick(\'btn\',\'t2ct1-zs1\',\'赠送\');">赠送</a></td>';
              qqlisthtml +=  	'</tr>';  

              fuin=fuin+","+list[i]['userid'];
              ftype=ftype+","+list[i]['friendtype'];
              fex1=fex1+","+list[i]['ext1'];
              algo_type= res.jData.algo_type;
            }
            $(".hylist").html(qqlisthtml);
          }else{
            //$(".t2ct1-box").hide();
            //$(".btn-yjzs1").hide();
            //$(".btn-yjzs2").hide();
            //$(".t2ct1-box1").show();
          }
      },
      onFail: (err) => {
          milo.miloAlert(err.sMsg || err.msg)
      },
  })

}

//给好友发消息
function sendqq(fuinDmSet,num,isFive,stype,ext1){
  milo.Lottery.init({
    plat: 'pc',
    iActivityId: '541575',
    iFlowId: '934775',
    flowConfig: {
      sData: {
        "fuin": fuinDmSet,
        "stype": stype,
        "ext1": ext1,
        "algo_type": algo_type
      }
    },
    withAreaInfo: false,
    onSuccess: (res) => {
      var fuinDm = fuin.split(",");
			var ftypeDm = ftype.split(",");
			var fex1Dm = fex1.split(",");
			if((fuinDm.length)-1>num&&isFive==1){
				var j = num+1;
				sendqq(fuinDm[j],j,1,ftypeDm[j],fex1Dm[j]);
			}else{
				if(res.iRet==0){
					milo.miloAlert("恭喜您，分享成功~")
				}else{
					milo.miloAlert("抱歉，分享失败~")
				}
			}
    },
    onFail: (err) => {
        //milo.miloAlert(err.sMsg || err.msg)
        var fuinDm = fuin.split(",");
        var ftypeDm = ftype.split(",");
        var fex1Dm = fex1.split(",");
        if((fuinDm.length)-1>num&&isFive==1){
          var j = num+1;
          sendqq(fuinDm[j],j,1,ftypeDm[j],fex1Dm[j]);
        }else{
          milo.miloAlert("抱歉，分享失败~")
        }
    },
  }).then(lottery => {
      lottery.getGift()
  })
}

function sendQQall(isFive){
    if(fuin){
      var fuinDm = fuin.split(",");
		  var ftypeDm = ftype.split(",");
		  var fex1Dm = fex1.split(",");
      sendqq(fuinDm[1],1,isFive,ftypeDm[1],fex1Dm[1]);
    }else{
      milo.miloAlert('请选择好友~')
    }
}
function sendcard1(ele){
  let cardinfo = $(".cardinfo_1").val();  
  if(cardinfo==''){
    milo.miloAlert("请填写好友的求卡码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].cardinfo = cardinfo
  return true;
}
function sendcard2(ele){
  let cardinfo = $(".cardinfo_2").val();  
  if(cardinfo==''){
    milo.miloAlert("请填写好友的求卡码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].cardinfo = cardinfo
  return true;
}
function sendcard3(ele){
  let cardinfo = $(".cardinfo_3").val();  
  if(cardinfo==''){
    milo.miloAlert("请填写好友的求卡码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].cardinfo = cardinfo
  return true;
}
function sendcard4(ele){
  let cardinfo = $(".cardinfo_4").val();  
  if(cardinfo==''){
    milo.miloAlert("请填写好友的求卡码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].cardinfo = cardinfo
  return true;
}

function getTeamid(ele){
  let teamid = $(".team_id_copy").val();  
  if(teamid==''){
    milo.miloAlert("请填写要加入的团队ID~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].team_id = teamid
  return true;
}

function getTeamid2(ele){
  if(area>0){
    let team_id2 = $(".team_id_copy2").val();  
    if(team_id2==''){
      milo.miloAlert("请填写要加入的团队ID~")
      return false;
    }
    ;(window as any)[`sData${ele.class}`].area = area
    ;(window as any)[`sData${ele.class}`].team_id = team_id2
    return true;
  }else{
    CFbind.initbind('myarea','bindarea()')
    return false;
  }
}

function getTeamid3(ele){
  let teamid = $(".team_id_copy3").val();  
  if(teamid==''){
    milo.miloAlert("请填写要加入的团队ID~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].team_id = teamid
  return true;
}

function getNameAndChannel(ele){
  let preNickName = $(".preNickName").val()
  if(preNickName==''){
    milo.miloAlert("请填写角色名称~")
    return false;
  }
  let urlInfo = window.location.href.split('/');
  if(urlInfo[5]=='qd'){ 
    var hkChannel = getchannelCode(6)
  }else{
    var hkChannel = getchannelCode(5)
  }
  
  if(hkChannel==undefined){
    milo.miloAlert("抱歉，不是允许的渠道~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].preNickName = preNickName
  ;(window as any)[`sData${ele.class}`].hkChannel = hkChannel
  return true;
}

var channelItemArr = {
  hy: 1,
  djc: 2,
  gj: 3,
  llq: 4,
  wegame: 5,
  wegames: 5,
  hyh5: 1,
  djch5: 2
}
/*$('.widget').click(function () {
  channelJob()
})*/
function getChannelItem(ele) {
  let urlInfo = window.location.href.split('/');
  var urlArr = urlInfo[6].split('.')
  var Channelid = channelItemArr[urlArr[0]]
  if (!Channelid) {
    milo.miloAlert('渠道错误~')
    return false;
  }
  ;(window as any)[`sData${ele.class}`].dmidqd = Channelid
  return true;

}


function copyTeamId(){
  if(tab2TeamId){
    copyText(tab2TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyTeamId2(){
  if(tab5TeamId){
    copyText(tab5TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyTeamId3(){
  if(tab8TeamId){
    copyText(tab8TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyKOLId(){
  if(myKOLcode){
    copyText(myKOLcode,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先生成大咖码再来复制哦~")
  }
}
function copycard(id){
  if(cardinfo[id]){
    copyText(cardinfo[id],milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先登录页面再来复制哦~")
  }
}
//云游戏跳转
function yunGame() {
  if(isPage == 'index'){
    //window.location.href = 'https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD';
    open('https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD');
  }else{
    milo.miloAlert('请去PC活动页面参加')
  }
}
//云游戏跳转
function yunGamejump() {
  if(isPage == 'H5'){
    window.location.href = 'https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD#/';
  }else{
    window.open('https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD#/');
  }
}

function gameDown(){
  if(isPage == 'H5'){
    //window.location.href = 'https://cfhd.cf.qq.com/cp/a20210607download/';
  }else{
    window.open('https://cfhd.cf.qq.com/cp/a20210607download/');
  }
}

function gameDownBefore(){
  if(isPage == 'H5'){
    milo.miloAlert('请前往PC端下载')
    return false;
  }
  return true;
}


//绑定cf大区
function bindarea() {
  if (CFbind.CFareaid > 0) {
    area = CFbind.CFareaid    
    if (isPage == 'H5') {
      $('#myarea').text(CFbind.CFareaname)
    } else {
      $('#myarea').text(CFbind.CFareaname + ' ' + CFbind.CFername)
    }
    milo.miloAlert('绑定大区成功')
    closeDialog()
  } else {
    milo.miloAlert('在该服务器上未获取到角色信息！')
  }
}


//绑定平台
function binddypt(){
  if(isPage=='index'){
    var instance = new LivelinkManager();
    instance.init({
      actId: 3648, // 活动ID
      gameId: 'cfhd', // 游戏ID
      loginType: 'ptlogin', // 登录方式 
      closeAfterBind: true, // 绑定成功后是否关闭弹窗
      gameAuthScene: 'act_3836', // 授权场景值
      onBoundSuccess(data) { // 绑定账号成功的回调
      var dyid = data.platAccount.uid;
      var dynick = decodeURIComponent(data.platAccount.nickName);
      if(dyid){
        initPage();
      }
      //console.log('onBoundSuccess', data);
      },
      onBoundError(errData) { // 绑定账号失败的回调
      console.log('onBoundError', errData);
      },
      initialedEvent(data) { // 初始化成功的回调
      console.log('initialedEvent', data);
      },
    });
  }else{
    milo.miloAlert("请先去PC活动页绑定平台账号再来参与活动哦~")
  }
}

function bindhypt(){
  if(isPage=='index'){
    var instance = new LivelinkManager();
    instance.init({
      actId: 3647, // 活动ID
      gameId: 'cfhd', // 游戏ID
      loginType: 'ptlogin', // 登录方式 
      closeAfterBind: true, // 绑定成功后是否关闭弹窗
      gameAuthScene: 'act_3837', // 授权场景值
      onBoundSuccess(data) { // 绑定账号成功的回调
      let hyid = data.platAccount.uid;
      let hynick = decodeURIComponent(data.platAccount.nickName);
      if(hyid){
        initPage();
      }
      //console.log('onBoundSuccess', data);
      },
      onBoundError(errData) { // 绑定账号失败的回调
      console.log('onBoundError', errData);
      },
      initialedEvent(data) { // 初始化成功的回调
      console.log('initialedEvent', data);
      },
    });
  }else{
    milo.miloAlert("请先去PC活动页绑定平台账号再来参与活动哦~")
  }
}

function bindkspt(){
  if(isPage=='index'){
    var instance = new LivelinkManager();
    instance.init({
      actId: 4610, // 活动ID
      gameId: 'cfhd', // 游戏ID
      loginType: 'ptlogin', // 登录方式 
      closeAfterBind: true, // 绑定成功后是否关闭弹窗
      gameAuthScene: 'act_4610', // 授权场景值
      onBoundSuccess(data) { // 绑定账号成功的回调
      let ksid = data.platAccount.uid;
      let hynick = decodeURIComponent(data.platAccount.nickName);
      if(ksid){
        initPage();
      }
      //console.log('onBoundSuccess', data);
      },
      onBoundError(errData) { // 绑定账号失败的回调
      console.log('onBoundError', errData);
      },
      initialedEvent(data) { // 初始化成功的回调
      console.log('initialedEvent', data);
      },
    });
  }else{
    milo.miloAlert("请先去PC活动页绑定平台账号再来参与活动哦~")
  }
}

//屏蔽中间4位数字
function resetqq(qq) {
  var str = String(qq)
  var len = str.length;
  if (len >= 7) {
    var reg = str.slice(-7, -3)
    return str.replace(reg, "****")
  } else if (len < 7 && len >= 6) {
    //1234567
    var reg = str.slice(-4, -2)
    return str.replace(reg, "**")
  } else if (len < 6 && len >= 4) {
    //1234567
    var reg = str.slice(-2, -1)
    return str.replace(reg, "**")
  }else{
	return 	str;
  }
}

//跳转tab
function jumpttt(tabIndex, el) {
  $('.nav a').eq(tabIndex - 1).addClass('on').siblings().removeClass('on')
  var index=$('.nav a').eq(tabIndex - 1).attr("data-navbtn");
  (window as any).iTab(index);
  $(".tab-box>.tab-ct").each(function(){
      var ct=$(this).attr("data-ct");
          if(index==ct){
              $(this).show().siblings().hide();
          }
  })
  var timer = setTimeout(function () {
      if(el==".top"){
          $(window).scrollTop(0); 
      }else{
          var elSt = $(el).offset().top;
          $(window).scrollTop(elSt);
      }
  }, 100)
}

//预约方法
function yyfun(){
  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
    plat: plat,
    iActivityId: iActivityId,
    iFlowId: 937446,
    withAreaInfo: false,
    forbidLoading: false,
    flowConfig:{
      sData: {
        'dmid52':1
      }
    },
    onSuccess: (res) => {
      console.log(res)
      milo.miloAlert("恭喜您获得了礼包： MK12 神罚天使（7天）+1000GP,预约新版本成功~")
      initPage()
    },
    onFail: (err) => {
      milo.miloAlert(err.sMsg)
    },
  })
}

;(window as any).yunGamejump = yunGamejump  
;(window as any).copyTeamId = copyTeamId
;(window as any).copyTeamId2 = copyTeamId2
;(window as any).copyTeamId3 = copyTeamId3
;(window as any).copyKOLId = copyKOLId
;(window as any).yunGame = yunGame
;(window as any).binddypt = binddypt
;(window as any).bindkspt = bindkspt
;(window as any).bindarea = bindarea 
;(window as any).joinTeam = joinTeam
;(window as any).djcbuy = djcbuy
;(window as any).initPage = initPage
;(window as any).sendqq = sendqq
;(window as any).qqlist = qqlist
;(window as any).sendQQall = sendQQall
;(window as any).copycard = copycard
;(window as any).milo.miloAlert = milo.miloAlert
;(window as any).LoginService = LoginService



